import axios from "axios";
import settings from "../settings";
import router from "../router";

let new_shop_data = {
    is_new: true,
    name: null,
    store_id: null,
    type: null,
    image: null,
    comment: null,
    address: null,
    address_place: null,
    address_parish: null,
    address_county: null,
    latitude: null,
    longitude: null,
    additional_field: null,
    store: {
        company_name: null
    },
    contacts: []
};
let new_store_info = {
    company_name: null,
    chain_name: null,
    identification_code: null,
    address: null
};
let initialState = {
    loadingUnmatchedShopsList: false,
    loadingUnmatchedShopData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    unmatchedShops: [],
    activeUnmatchedShop: {},
    unmatchedShopDialog: false,
    errorMessage: "",
    tableOptions: null,
    shops: null,
    shop: null,
    // Unmatched clients state
    activeTab: 'clients',
    loadingUnmatchedClientsList: false,
    unmatchedClients: [],
    activeUnmatchedClient: {},
    clients: [],
    rematchTaskRunning: false,
    unmatchedShopsCountPreload: 0
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getUnmatchedClientsList({ commit }) {
            commit("setUnmatchedClientsListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/unmatched-clients/");
                if (response.status === 200) {
                    let data = response.data;
                    commit("addUnmatchedClients", data.records);
                    commit("addClients", data.clients);
                    commit("setRematchTaskRunning", data.rematch_task_running || false);
                    commit("setUnmatchedShopsCount", data.unmatched_shops_count || 0);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setUnmatchedClientsListLoading", false);
        },
        async getUnmatchedShopsList({ commit }) {
            commit("setRequestSuccess", false);
            commit("setUnmatchedShopsListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/unmatched-shops/");
                if (response.status === 200) {
                    let data = response.data;
                    commit("addUnmatchedShops", data.invoices);
                    commit("addShops", data.shops);
                    commit("setUnmatchedShopsListLoading", false);
                }
            } catch (e) {
                console.log(e);
                commit("setUnmatchedShopsListLoading", false);
            }
        },
        async getUnmatchedShopsData({ commit }, { invoiceId, invoiceType }) {
            commit("setRequestSuccess", false);
            commit("setUnmatchedShopDataLoading", true);
            try {
                let response = await axios.get(`${settings.api_url}/unmatched-shop/${invoiceId}/${invoiceType}`);
                if (response && response.data) {
                    let data = response.data;
                    commit("setActiveUnmatchedShop", data.invoice_data);
                }
                commit("setUnmatchedShopDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setUnmatchedShopDataLoading", false);
            }
        },
        async submitUnmatchedShopsData({ commit, dispatch, state }, shopData) {
            commit("setRequestSuccess", false);
            commit("setErrorMessage", "");
            commit("setUnmatchedShopDataLoading", true);
            let payload = {
                ...shopData,
                shop: state.shop
            };
            try {
                let response = await axios.post(settings.api_url + "/unmatched-shop/", payload);
                if (response && response.data.success === 1) {
                    dispatch("getUnmatchedShopsList");
                    commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
            }
            commit("setUnmatchedShopDataLoading", false);
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addUnmatchedShops(state, shops) {
            state.unmatchedShops = shops;
        },
        addShops(state, shops) {
            state.shops = shops;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setUnmatchedShopsListLoading(state, value) {
            state.loadingUnmatchedShopsList = value;
        },
        setUnmatchedShopDataLoading(state, value) {
            state.loadingUnmatchedShopData = value;
        },
        setActiveUnmatchedShop(state, client) {
            state.activeUnmatchedShop = client;
        },
        updateUnmatchedShopProperty(state, { prop, value }) {
            state.activeUnmatchedShop = {
                ...state.activeUnmatchedShop,
                [prop]: value
            };
        },
        addNewShopData(state) {
            state.shop = {
                ...new_shop_data,
                name: state.activeUnmatchedShop.customer_name,
                address: state.activeUnmatchedShop.customer_address,
                address_place: state.activeUnmatchedShop.customer_city,
                address_county: state.activeUnmatchedShop.customer_county
            };
        },
        updateNewShopProperty(state, { prop, value }) {
            state.shop = {
                ...state.shop,
                [prop]: value
            };
        },
        resetNewShopData(state) {
            state.shop = null;
        },
        addNewStoreData(state) {
            state.shop.store = { ...new_store_info };
        },
        updateNewStoreProperty(state, { prop, value }) {
            state.shop.store = {
                ...state.shop.store,
                [prop]: value
            };
        },
        resetNewStoreData(state) {
            state.shop.store = { company_name: null };
        },
        // Unmatched clients mutations
        setActiveTab(state, tab) {
            state.activeTab = tab;
        },
        setUnmatchedClientsListLoading(state, value) {
            state.loadingUnmatchedClientsList = value;
        },
        addUnmatchedClients(state, clients) {
            state.unmatchedClients = clients;
        },
        addClients(state, clients) {
            state.clients = clients;
        },
        setActiveUnmatchedClient(state, client) {
            state.activeUnmatchedClient = client;
        },
        setRematchTaskRunning(state, value) {
            state.rematchTaskRunning = value;
        },
        setUnmatchedShopsCount(state, value) {
            state.unmatchedShopsCountPreload = value;
        }
    },
    getters: {
        unmatchedShopsCount: state => {
            if (state.unmatchedShops && state.unmatchedShops.length) {
                return state.unmatchedShops.length;
            }
            // Use preloaded count if shops list not yet loaded
            return state.unmatchedShopsCountPreload || 0;
        },
        unmatchedClientsCount: state => {
            if (state.unmatchedClients && state.unmatchedClients.length) {
                return state.unmatchedClients.length;
            } else return 0;
        }
    }
};
